(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orovera-purchase-proof"] && !Shopify.designMode) return;
  try {
    function oroPreparationDate(now) {
  var date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3, 12);
  var days = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
  var months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
  return days[date.getDay()] + ' ' + months[date.getMonth()] + ', ' + date.getDate();
}
function oroRefreshPreparationDates() {
  var text = oroPreparationDate(new Date());
  document.querySelectorAll('[data-oro-prep-date]').forEach(function (element) { element.textContent = text; });
}
oroRefreshPreparationDates();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', oroRefreshPreparationDates, {once: true});
document.addEventListener('shopify:section:load', oroRefreshPreparationDates);
document.addEventListener('visibilitychange', function () { if (!document.hidden) oroRefreshPreparationDates(); });

function oroInitAvatarCarousels() {
  document.querySelectorAll('[data-oro-avatar-carousel]').forEach(function(root) {
    if(root.dataset.oroReady) return;
    root.dataset.oroReady='1';
    var track=root.querySelector('.oro-proof-avatar-track');
    var pool=Array.from(root.querySelector('template').content.children);
    if(pool.length<4 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var head=0, timer;
    function tick() {
      if(!root.isConnected) return;
      if(document.hidden || root.matches(':hover')) {timer=setTimeout(tick,2000);return;}
      track.classList.add('is-sliding');
      timer=setTimeout(function(){
        if(!root.isConnected) return;
        track.firstElementChild.remove();
        head=(head+1)%pool.length;
        track.classList.remove('is-sliding');
        track.appendChild(pool[(head+3)%pool.length].cloneNode(true));
        timer=setTimeout(tick,1530);
      },470);
    }
    timer=setTimeout(tick,2000);
  });
}
oroInitAvatarCarousels();
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',oroInitAvatarCarousels,{once:true});
document.addEventListener('shopify:section:load',oroInitAvatarCarousels);
  } catch(e) { console.error(e); }
})();

})();
